import { render, staticRenderFns } from "./ModalSuportePaciente.vue?vue&type=template&id=9c90026e&scoped=true"
import script from "./ModalSuportePaciente.vue?vue&type=script&lang=ts"
export * from "./ModalSuportePaciente.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuportePaciente.vue?vue&type=style&index=0&id=9c90026e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c90026e",
  null
  
)

export default component.exports